import React, { useState } from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import ModelDrawerAgendaOnly from '@components/ContactDetails/ModelDetails/Drawer/ModelDrawerAgendaOnly';
import EventModelActions from '@components/EventDrawer/EventDrawerUi/EventModelActions';
import OptionNumber from '@components/EventDrawer/EventDrawerUi/OptionNumber';
import PreviousEventsButton from '@components/EventDrawer/EventDrawerUi/PreviousEventsButton';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    font-size: 1.1rem;
    font-weight: 400;
    width: 100%;
    padding: ${(props) => (props.withPadding ? '20px 16px 0px 0px' : '0px')};
    /* margin-top: ${(props) => (props.withMarginTop ? '12px' : '-4px')}; */

    margin-bottom: 1rem;

    @media only screen and (max-width: 720px) {
        /* flex-direction: column;
        align-items: flex-start; */
        justify-content: space-between;
        width: 100%;
        gap: 0.25rem;
        font-size: 1rem;
        padding: 0;
    }

    .model-name-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 0.25rem;

        .model-name {
            margin-right: 5px;
            text-transform: capitalize;

            &.is-confirmed {
                font-weight: 700;
            }

            &.is-cancelled {
                ${(props) => props.theme.RedLineThrough(1)}
                color: ${(props) => props.theme.TextColorMuted};
            }

            &.is-confirmed.is-cancelled {
                ${(props) => props.theme.RedLineThrough(2)}
            }

            @media only screen and (max-width: 720px) {
                width: 100%;
            }
        }

        .model-cancel-info {
        }
    }

    .model-icons-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 1rem;
    }

    .model-actions {
        margin-left: auto;
    }
`;

const BookingEventSingleModelName = ({
    model,
    withPadding,
    withMarginTop,
    currentModel,
    eventData,
    eventDateInfo,
    reloadGroupedModels,
    onExtendOptionNumberToAllDates,
    afterUpdate,
    onReloadEventStatus,
}) => {
    const [isOpenModelDrawer, setIsOpenModelDrawer] = useState(false);

    const renderPopOver = () => {
        let eventDateModel;
        if (eventDateInfo) {
            eventDateModel = eventDateInfo.EventDatesModels.find((eventDateModel) => eventDateModel.ID === model.ID);
        }
        return (
            <Popover
                overlayClassName="nw-popover"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placement="left"
                title={`Cancel by ${eventDateModel ? eventDateModel.CancelledByName : eventData.CancelledByName}`}
                content={() => {
                    if (eventDateInfo) {
                        return <>{eventDateModel.CancellationNote && <div>{eventDateModel.CancellationNote}</div>}</>;
                    } else if (eventData) {
                        return <>{eventData.CancellationNote && <div>{eventData.CancellationNote}</div>}</>;
                    }
                }}
            >
                <NwIcon icon={byPrefixAndName.fass['message-xmark']} color={StyleVariables.DangerColor} />
            </Popover>
        );
    };

    const handleOpenModelDrawer = () => {
        setIsOpenModelDrawer(true);
    };

    const onOptionUpdate = () => {
        afterUpdate();
    };

    const onAllDatesOptionUpdate = (modelid, optionnumber) => {
        onExtendOptionNumberToAllDates(modelid, optionnumber);
        afterUpdate();
    };

    const handleCloseModelDrawer = () => {
        setIsOpenModelDrawer(false);
    };

    return (
        <Wrapper withPadding={withPadding} withMarginTop={withMarginTop}>
            <div className="model-name-wrapper">
                <span
                    className={`model-name${model.Cancel ? ' is-cancelled' : ''}${model.OptionNumber === 10 ? ' is-confirmed' : ''}`}
                >
                    {getContactName(model.ModelID).toLowerCase()}
                </span>
                <div className="model-cancel-info">{model.Cancel && renderPopOver()}</div>
            </div>
            <div className="model-icons-wrapper">
                <OptionNumber
                    className="model-option-number"
                    key={model.OptionNumber}
                    number={model.OptionNumber}
                    event={eventData}
                    eventDateInfo={eventDateInfo}
                    selectedModel={currentModel}
                    eventDatesModel={model}
                    reloadGroupedModels={reloadGroupedModels}
                    onExtendOptionNumberToAllDates={onAllDatesOptionUpdate}
                    onChangeOptionNumber={onOptionUpdate}
                />
                <EventModelActions
                    model={model}
                    eventData={eventData}
                    eventDateInfo={eventDateInfo}
                    reloadGroupedModels={reloadGroupedModels}
                    afterUpdate={afterUpdate}
                    onReloadEventStatus={onReloadEventStatus}
                />
                <PreviousEventsButton modelID={model.ModelID} eventData={eventData} />
                <NwIcon pointer icon={byPrefixAndName.fasl['sidebar-flip']} onClick={handleOpenModelDrawer} />
            </div>
            {isOpenModelDrawer && (
                <ModelDrawerAgendaOnly
                    calendarDefaultDate={eventDateInfo.FromDate}
                    modelID={model.ModelID}
                    onClose={handleCloseModelDrawer}
                />
            )}
        </Wrapper>
    );
};

export default BookingEventSingleModelName;
